let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7LPdQ")).then(() => parcelRequire('7UfC0'));